import {
  Home, Phone, MapPin, User, Car, Search, MessageSquare, ClipboardList, ClipboardCheck,
  CheckCircle, ArrowRight, Signal, Clock, BookUser,
} from "lucide-react";

export const MSG_FILE_ACCEPT = "image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt,.csv";
export const IDLE_LOCK_MS = 120000;

// Dark navy tactical theme (per agency mockup).
export const t = {
  bg: "#070f1f", panel: "#0d1a30", surface: "#122642", head: "#0a1526", border: "#1d3252",
  text: "#E7EEF9", dim: "#8299bd", blue: "#2563EB", green: "#16A34A", amber: "#D9A441", red: "#DC2626", gold: "#E0B23C",
};

export const STATUS_META = {
  available: ["AVAILABLE", "#16A34A"], enroute: ["EN ROUTE", "#E0B23C"], dispatched: ["DISPATCHED", "#2563EB"],
  onscene: ["ON SCENE", "#16A34A"], delayed_onscene: ["DELAYED ON SCENE", "#EA580C"], transport: ["TRANSPORT", "#8B5CF6"], busy: ["BUSY", "#D9A441"], outofservice: ["OUT OF SERVICE", "#8299bd"], acknowledged: ["ACKNOWLEDGED", "#0EA5E9"],
};

export const STATUS_ACTIONS = [
  ["acknowledged", "ACK", "#0EA5E9", CheckCircle],
  ["enroute", "ENROUTE", "#2563EB", ArrowRight],
  ["onscene", "ON SCENE", "#16A34A", MapPin],
  ["delayed_onscene", "DELAYED ON SCENE", "#EA580C", Clock],
  ["available", "AVAIL", "#0891B2", Signal],
  ["clear", "CLEAR", "#16A34A", CheckCircle],
];

export const NAV = [
  ["home", "HOME", Home], ["calls", "CALLS", Phone], ["map", "MAP", MapPin],
  ["persons", "PERSONS", User], ["vehicles", "VEHICLES", Car], ["ncic", "NCIC", Search],
  ["fi", "FIELD INT", ClipboardCheck], ["dar", "DAR / CHECKS", ClipboardList],
  ["messages", "MESSAGES", MessageSquare], ["reports", "REPORTS", ClipboardList], ["directory", "DIRECTORY", BookUser],
];

export const FIELD_ACCESS = [
  ["Field Interview", "Field Interview / FI Card", "#8B5CF6"],
  ["Banning Notice / Trespass Warning", "Banning Notice / Trespass Warning", "#DC2626"],
  ["Use-of-Force Report", "Use of Force Report", "#DC2626"],
  ["Search Warrant Request", "Search Warrant Request", "#D9A441"],
];

export const FORM_MAP = { "Field Interview": "fi_card", "Banning Notice / Trespass Warning": "banning", "Use-of-Force Report": "use_of_force", "Search Warrant Request": "warrant" };

export const REPORT_TYPES = ["Incident Report", "Supplement", "Arrest Report", "Crash Report", "Traffic Citation"];

export function elapsed(from) {
  if (!from) return "00:00:00";
  const s = Math.max(0, Math.floor((Date.now() - new Date(from).getTime()) / 1000));
  return [Math.floor(s / 3600), Math.floor((s % 3600) / 60), s % 60].map((n) => String(n).padStart(2, "0")).join(":");
}

export function initials(str) {
  const s = String(str || "").trim();
  if (!s) return "??";
  const parts = s.split(/[\s\-_]+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  return s.slice(0, 2).toUpperCase();
}

// A message is unread for THIS operator if it wasn't sent by them and they haven't read it.
export const isUnreadMsg = (m, myUnit, user) =>
  m.from_unit !== myUnit && m.from_user_id !== user?.id && !(m.reads || []).includes(user?.name);
